import * as React from "react";
import { useTimer } from 'react-timer-hook';

interface ICountdownTimerProps {
    expiryDate: Date;
    color?: string;
    hideSeconds?: boolean;
    onExpire?();
    style?: React.CSSProperties
}

const CountdownTimer: React.FunctionComponent<ICountdownTimerProps> = (props) => {

    const {
        seconds,
        minutes,
        hours,
        days
    } = useTimer({ expiryTimestamp: props.expiryDate, onExpire: props.onExpire });

    if (!props.expiryDate) {
        return null;
    }

    const getMessageText = (): string => {

        // Special case, if hide seconds is set and there is less than 1 minute, always show 1 minute
        if (!days && !hours && !minutes && seconds < 60) {
            return '1 minute';
        }

        let parts: string[] = [];

        // Days
        if (days > 0) {
            if (days == 1) {
                parts.push('1 day');
            }
            else {
                parts.push(`${days} days`)
            }
        }

        // Hours
        if (hours > 0) {
            if (hours == 1) {
                parts.push('1 hour');
            }
            else {
                parts.push(`${hours} hours`)
            }
        }

        // Minutes
        if (minutes > 0) {
            if (minutes == 1) {
                parts.push('1 minute');
            }
            else {
                parts.push(`${minutes} minutes`)
            }
        }

        // Seconds
        if (!props.hideSeconds && seconds > 0) {
            if (seconds == 1) {
                parts.push('1 second');
            }
            else {
                parts.push(`${seconds} seconds`)
            }
        }

        return parts.join(" ");
    };

    return <span style={props.style}>{getMessageText()}</span>;
}

export default CountdownTimer